import { DEVICE } from './common';

const DEVICE_MODEL_LIST = [
  {
    label: DEVICE.BIOFLUX,
    value: DEVICE.BIOFLUX,
  },
  {
    label: DEVICE.BIOCORE,
    value: DEVICE.BIOTRES,
  },
  {
    label: DEVICE.BIOCORE_PRO,
    value: DEVICE.BIOTRES_PRO,
  },
];

const VIRTU_OX_DEVICE_MODEL_LIST = [
  {
    label: DEVICE.BIOFLUX,
    value: DEVICE.BIOFLUX,
  },
  {
    label: DEVICE.BIOCORE,
    value: DEVICE.BIOTRES,
  },
  {
    label: DEVICE.BIOCORE_PRO,
    value: DEVICE.BIOTRES_PRO,
  },
  {
    label: DEVICE.ICOR,
    value: DEVICE.ICOR,
  },
];

const CARDIO_ONE_DEVICE_MODEL_LIST = [
  {
    label: DEVICE.BIOCORE_PRO,
    value: DEVICE.BIOTRES_PRO,
  },
];

export { CARDIO_ONE_DEVICE_MODEL_LIST, DEVICE_MODEL_LIST, VIRTU_OX_DEVICE_MODEL_LIST };
